module.exports = __webpack_public_path__ + "images/logos/logo-soc2-a49e71207684b349b4879f2be45b54a0.webp";